import React from "react";
import LogoImg from "assets/images/logo1.svg";

const Logo = ({ maxWidth = "260px" }: { maxWidth?: string | undefined }) => (
  <img src={LogoImg} alt="logo" style={{ maxWidth }} draggable={false} />
);

export default Logo;
